import { render, staticRenderFns } from "./UltimaModifica.vue?vue&type=template&id=28b7b925"
import script from "./UltimaModifica.vue?vue&type=script&lang=js"
export * from "./UltimaModifica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports